import { render, staticRenderFns } from "./ButtonSignInTwitter.vue?vue&type=template&id=3270b49e&scoped=true&"
import script from "./ButtonSignInTwitter.vue?vue&type=script&lang=js&"
export * from "./ButtonSignInTwitter.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSignInTwitter.vue?vue&type=style&index=0&id=3270b49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270b49e",
  null
  
)

export default component.exports